/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Translation_Notes_LabelInputs */



/**
* | output |
* | --- |
* | "Translation Notes" |
*
* @param {Knp_Guide_Translation_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_translation_notes_label = /** @type {((inputs?: Knp_Guide_Translation_Notes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Translation_Notes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungshinweise")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания к переводу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译说明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳メモ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas de tradução")
	return /** @type {LocalizedString} */ ("Translation Notes")
});